import { render, staticRenderFns } from "./case-batch-confirm.vue?vue&type=template&id=751a1685"
import script from "./case-batch-confirm.vue?vue&type=script&lang=ts"
export * from "./case-batch-confirm.vue?vue&type=script&lang=ts"
import style0 from "./case-batch-confirm.vue?vue&type=style&index=0&id=751a1685&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports